var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.943%",
    y1: "19.883%",
    x2: "100%",
    y2: "74.562%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.768 5.176h-.47v-.675c0-.276-.306-.501-.682-.501H6.384c-.376 0-.683.225-.683.5v.676h-.47C4.555 5.176 4 5.711 4 6.365v4.446C4 11.465 4.554 12 5.232 12h5.536c.678 0 1.232-.535 1.232-1.189V6.365c0-.654-.554-1.189-1.232-1.189Zm-1.074 3.83a.405.405 0 0 1-.41.396h-.58v.56a.405.405 0 0 1-.411.397h-.585a.405.405 0 0 1-.411-.397v-.56h-.58a.405.405 0 0 1-.41-.396V8.44c0-.218.184-.395.41-.396h.58v-.56c.001-.218.184-.396.411-.396h.585c.226 0 .41.178.41.396v.56h.58c.227.001.41.178.411.396v.565Zm.008-3.83H6.298v-.394c0-.184.205-.334.455-.334h2.494c.25 0 .455.15.455.334v.394Z",
    fill: "#B41CFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.3d65d7981b3767f23ed7ad1b0d1abb66.svg";
export { ForwardRef as ReactComponent };